"use client";

import { Link } from "@/i18n/navigation";
import clsx from "clsx";

/**
 * CTA tıklamasında dataLayer'a push eder (cta_click).
 * dataLayerPayload section config'den gelir (PageBuilder); cta_button kart başlığıdır.
 */
function pushCtaClickDataLayer(dataLayerPayload, cta_button) {
  if (typeof window === "undefined" || !dataLayerPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...dataLayerPayload,
    cta_button: cta_button ?? "",
  });
}

/**
 * PopularListItemCard
 * ExpandablePopularList içindeki satır yapısına benzeyen basit bir kart.
 * Hem rota (cheapestFlights) hem de havalimanı (popularAirports) item'larını destekler.
 * dataLayerPayload varsa (hotel expandable-list) tıklamada cta_click event tetiklenir.
 */
export default function PopularListItemCard({ item, dataLayerPayload, className = "" }) {
  if (!item) return null;

  const isFlightRoute =
    typeof item.OriginCityName === "string" &&
    typeof item.DestinationCityName === "string";

  const label = isFlightRoute
    ? `${item.OriginCityName}- ${item.DestinationCityName} Uçak Bileti`
    : item.Title || item.Name || "";

  const href = item.RedirectUrl || "/";

  const handleClick = () => {
    if (dataLayerPayload) {
      pushCtaClickDataLayer(dataLayerPayload, label);
    }
  };

  return (
    <Link
      className={clsx(
        "cursor-pointer text-base font-medium text-gray-900 lg:text-lg",
        className,
      )}
      href={href}
      onClick={handleClick}
    >
      {label}
    </Link>
  );
}


